/** * * Asynchronously loads the component for
TwoFactorAuthentication
* */ import { lazyLoad } from "utils/loadable";
export const TwoFactorAuthentication = lazyLoad(
  () => import("./index"),
  (module) => module.TwoFactorAuthentication
);
